<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->

    <template>
      <!-- <v-row>
        <v-col
          cols="12"
          sm="6"
          md="6"
          dense
          v-for="vd in visitor_visit_data_list"
          :key="vd.vvid"
        >
          <v-card v-if="vd.isrejected == 'No' && vd.isapproved == 'No'">
            {{ vd }}
            <v-btn class="info" @click="save('Approve', vd)">Approve</v-btn>
            <v-btn class="warning" @click="save('Reject', vd)">Reject</v-btn>
          </v-card>
        </v-col>
      </v-row> -->

      <!-- shiv added card -->
      <v-container>
        <v-row>
          <v-col sm="6" md="6" dense v-for="vd in visitor_visit_data_list" :key="vd.vvid" :cols="vd.vvid">
            <v-card v-if="vd.isrejected == 'No' && vd.isapproved == 'No'" class="back-hover" fill-height :elevation="4">
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-img style="width: 240px; height: 200px; margin: 3px" class="shrink vi-img" contain
                    :src="awspath + vd.photo_file_path + vd.photo_file_name" v-if="vd.photo_file_path !== null"></v-img>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <br /><br />

                  <span>
                    <b> Name: </b> {{ vd.visitor_data.visitor_name }} </span><br />
                  <span>
                    <b> Contact: </b>{{ vd.visitor_data.visitor_mobile }} </span><br />
                  <span>
                    <b> Address: </b>{{ vd.visitor_data.visitor_address }} </span><br />

                  <span> <b> Purpose: </b>{{ vd.purpose }} </span><br />
                </v-col>
              </v-row>
              <v-card-actions>
                <v-col sm="6" md="6">
                  <v-btn class="info" @click="save('Approve', vd)">Approve</v-btn>
                </v-col>

                <v-col sm="6" md="6">
                  <v-btn class="warning" @click="save('Reject', vd)">Reject</v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- card end -->
    </template>

    <!-- Table - > {{ visitor_visit_data_list }} <br /> -->
    <v-card class="box" v-if="visitor_visit_data_list != null">
      <!-- excel export btn code -->
      <v-row dense>
        <!-- <v-col cols="12" sm="4" md="4" v-if="inward_outward_list.length != 0">
          <v-btn color="success" outlined rounded>
             <download-excel
              class="mr-2 pb-3 pt-2"
              :data="visitor_visit_data_list"
              :fields="table_fields"
              worksheet="VisitorList"
              name="VisitorList.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn>
        </v-col> -->
        <v-col cols="12" sm="4" md="4"></v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <v-data-table :headers="headers" :items="visitor_visit_data_list" :search="search" class="mytable1">
        <!-- <v-data-table :headers="headers"> -->
        <template v-slot:top>
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Visitor List</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <!-- photo icon -->
        <template v-slot:[`item.photo`]="{ item }">
          <div v-if="item.photo_file_path !== null">
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="
                viewPhoto(item);
              dialog_add_new = true;
              " title="Photo">mdi-eye</v-icon>
            </v-avatar>
          </div>
        </template>
        <!-- approve and reject -->
        <template v-slot:[`item.approved`]="{ item }">
          <div v-if="item.isapproved == 'Yes'">
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" color="green" title="Approved">mdi-check-bold</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:[`item.rejected`]="{ item }">
          <div v-if="item.isrejected == 'Yes'">
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" color="red" title="Rejected">mdi-check-bold</v-icon>
            </v-avatar>
          </div>
        </template>
        <!-- refresh icon -->
        <template v-slot:[`item.refresh`]="{ item }">
          <div v-if="item.isrejected == 'Yes' || item.isapproved == 'Yes'">
            <v-icon class="mr-2" color="green" @click="changethestatusapproveRejectVisit(item)">mdi-refresh</v-icon>
          </div>
          <div v-else>--</div>
        </template>
      </v-data-table>
    </v-card>

    <!-- dialog box for photo -->
    <v-dialog v-model="dialog_add_new" transition="dialog-top-transition" max-width="700px" max-height="800px">
      <v-card class="box">
        <v-toolbar class="toolbar" flat dense>
          <v-btn icon dark @click="dialog_add_new = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Visitor Name:&nbsp;{{ d_visitor_name }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <center>
          <v-img style="width: 280px; height: 350px; margin: 3px" contain
            :src="awspath + d_photo_file_path + d_photo_file_name" v-if="d_photo_file_path !== null"></v-img>
        </center>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    // extraBreadcrumbItems: [
  

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    dialog_add_new: false,
    visitor_visit_data_list: null,
    awspath: null,
    photo_file_path: null,
    photo_file_name: null,
    d_photo_file_path: null,
    d_photo_file_name: null,
    d_visitor_name: null,

    search: "",
    headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Mobile No", value: "visitor_data.visitor_mobile" },
      { text: "Visit Type", value: "visittype" },
      { text: "Visitor Name", value: "visitor_data.visitor_name" },
      { text: "Visitor Address", value: "visitor_data.visitor_address" },
      { text: "Purpose", value: "purpose" },
      { text: "Photo", value: "photo" },

      //   { text: "Approve", value: "isapproved" },
      { text: "IsApprove", value: "approved" },
      { text: "IsRejected", value: "rejected" },
      //   { text: "Rejected", value: "isrejected" },
      { text: "Approved/Rejected By", value: "approvalby" },
      { text: "Change The Status", value: "refresh" }, // Added refresh column
    ],
    table_fields: {
      "Sr. No": "srno",
      "Mobile No": "visitor_data.visitor_mobile",
      "Visit Type": "visittype",
      "Visitor Name": "visitor_data.visitor_name",
      "Visitor Address": "visitor_data.visitor_address",
      Purpose: "purpose",
      Approve: "isapproved",
      Rejected: "isrejected",
    },
  }),
  mounted() {
    // localStorage.setItem("photo_file_path", "");
    // localStorage.setItem("photo_file_name", "");

    this.onload();
  },
  created() {
    this.awspath = localStorage.getItem("awspath");
  },
  methods: {
    viewPhoto(item) {
      console.log("add people", item);
      this.d_photo_file_path = item.photo_file_path;
      this.d_photo_file_name = item.photo_file_name;
      this.d_visitor_name = item.visitor_data.visitor_name;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////
    onload() {
      this.overlay = true;
      axios
        .post("/visitorManagement/getVisitorApprovalList")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitor_visit_data_list = res.data.visitor_visit_data_list;
            // this.photo_file_path =
            //   res.data.visitor_visit_data_list.photo_file_path;
            // this.photo_file_name =
            //   res.data.visitor_visit_data_list.photo_file_name;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    }, //end
    /////////////////////////
    save(type, vd) {
      const formdata = {
        type: type,
        vvid: vd.vvid,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/approveRejectVisit", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.onload();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    }, //end

    changethestatusapproveRejectVisit(item) {
      if (!confirm("Are You Sure You Want To Changes the Status...?")) return;
      const formdata = {
        vvid: item.vvid,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/changethestatusapproveRejectVisit", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.onload();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
  },
};
</script>

<style scoped>
.back-hover {
  border-radius: 16px !important;
}

.back-hover:hover {
  box-shadow: 20px 20px 20px grey !important;
  -webkit-transition: box-shadow 0.3s ease-in !important;
}

.vi-img {
  border-radius: 60%;
  /* min-height: 500px;
  min-width: 500px; */
  max-width: 200px;
  max-height: 200px;
}
</style>